<template>
  <div class="container d-flex flex-column flex-md-row gap-3 align-items-start">
    <MobileHeader class="d-block d-md-none" />
    <Navbar />
    <router-view></router-view>
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { onMounted } from 'vue'

  // Components
  import Navbar from './Navbar.vue'
  import MobileHeader from './MobileHeader.vue'

  // Store
  import { useStore } from '@/store'
  const store = useStore()

  // Utils
  import Cookies from 'js-cookie'

  // Config
  import { CookieName } from '@/config/cookies'

  // Composables
  import { useHeaderFooter } from '@/composables/useHeaderFooter'

  const { injectHeaderAndFooter, removeHeaderAndFooter, needToRefetch } =
    useHeaderFooter()

  onMounted(async () => {
    // If needToRefetch, remove the current header and footer, inject the new one
    if (needToRefetch) {
      removeHeaderAndFooter()
      injectHeaderAndFooter(
        window.env.VUE_APP_MENU_DOMAIN,
        store.getters.getLocale,
        Cookies.get(CookieName.COMPANY)
      )
    }
  })
</script>
